export enum ESubscribeStep {
	SubscriptionInfo = 'subscriptionInfo',
	Summary = 'summary',
	Success = 'success',
}
